import { ActiveFeatures, TTDFeatureFlag } from '@saas/interfaces/core'
// import { useFlag, useUnleashContext } from '@unleash/proxy-client-react'
import { useEffect, useState } from 'react'
// import { useAppSelector } from '../store'

function useTTDFlag(flagName: TTDFeatureFlag) {
    const [resultValue, setResultValue] = useState(false)
    // const user = useAppSelector((state) => state.auth.user)
    // const updateContext = useUnleashContext()

    const enabled =  ActiveFeatures.includes(flagName) // useFlag(flagName)

    // useEffect(() => {
    //     if (user && user.email) {
    //         updateContext({
    //             userId: user.email,
    //         })
    //     }
    // }, [user.objectId])

    useEffect(() => {
        const result = ['staging', 'development'].includes(window._env_.REACT_APP_TTD_ENV) || enabled
        setResultValue(result)
    }, [enabled])

    return resultValue
}

export default useTTDFlag
